<template>
  <div class="collapse">
    <div class="title">
      <slot name="title">{{ title }}</slot>
      <el-button type="text" class="collapse-btn" @click="handleClick">
        <span class="expand-btn-text" v-show="nonExpand">{{ expandBtnText }} <i class="el-icon-d-arrow-left"></i></span>
        <span class="collapse-btn-text" v-show="!nonExpand">{{ collapseBtnText }} <i class="el-icon-d-arrow-left"></i></span>
      </el-button>
    </div>

    <div class="collapse-box" :class="{ 'is-collapsed': nonExpand }">
      <div class="collapse-pane">
        <slot>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    expandBtnText: {
      type: String,
      default: '展开'
    },
    collapseBtnText: {
      type: String,
      default: '收起'
    },
    isCollapsed: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  watch: {
    isCollapsed(newVal) {
      if (newVal != this.nonExpand) {
        this.nonExpand = newVal;
      }
    }
  },
  data() {
    return {
      nonExpand: this.isCollapsed
    }
  },
  methods: {
    handleClick() {
      this.nonExpand =!this.nonExpand
      this.$emit('update:isCollapsed', this.nonExpand)
    }
  }
}
</script>

<style lang="scss" scoped>
.collapse-box {
  display: grid;
  grid-template-rows: 1fr;
  transition: .5s ease-in-out;
  height: auto;
  overflow: hidden;
  .collapse-pane {
    min-height: 0;
  }
  &.is-collapsed {
    grid-template-rows: 0fr;
  }
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.expand-btn-text {
  i {
    transform: rotate(-90deg);
  }
}
.collapse-btn-text {
  i {
    transform: rotate(90deg);
  }
}
</style>
